import { render } from "./CancelamentoView.vue?vue&type=template&id=c7674ec8&ts=true"
import script from "./CancelamentoView.vue?vue&type=script&lang=ts"
export * from "./CancelamentoView.vue?vue&type=script&lang=ts"

import "./CancelamentoView.vue?vue&type=style&index=0&id=c7674ec8&lang=css"

import exportComponent from "/codebuild/output/src1991399693/src/agendamento-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__